// extracted by mini-css-extract-plugin
export var sliderRange = "_ct-2";
export var sliderRoot = "_ct-0";
export var sliderThumb = "_ct-3";
export var sliderTrack = "_ct-1";